import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sidebar-item__children" }

import { INavigationRoute } from '../NavigationRoutes'
  import { ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuMinimized',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

  const { t } = useI18n()
  
  const dropdownsValue = ref([])
  function isRouteActive(item: INavigationRoute) {
    return item.name === useRoute().name
  }
  function isItemChildsActive(item: INavigationRoute): boolean {
    if (!item.children) {
      return false
    }
    const isCurrentItemActive = isRouteActive(item)
    let isChildActive = false
    if (item.children) {
      isChildActive = !!item.children.find((child) =>
        child.children ? isItemChildsActive(child) : isRouteActive(child),
      )
    }
    return isCurrentItemActive || isChildActive
  }

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_sidebar_item_content = _resolveComponent("va-sidebar-item-content")!
  const _component_va_sidebar_item = _resolveComponent("va-sidebar-item")!
  const _component_va_sidebar_item_title = _resolveComponent("va-sidebar-item-title")!
  const _component_va_dropdown = _resolveComponent("va-dropdown")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (route, idx) => {
    return (_openBlock(), _createBlock(_component_va_dropdown, {
      key: idx,
      modelValue: dropdownsValue.value[idx],
      "onUpdate:modelValue": ($event: any) => ((dropdownsValue.value[idx]) = $event),
      placement: "right-start",
      offset: [1, 0]
    }, {
      anchor: _withCtx(() => [
        _createVNode(_component_va_sidebar_item, {
          active: isItemChildsActive(route),
          to: route.children ? undefined : { name: route.name }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_sidebar_item_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: route.meta.icon,
                  class: "va-sidebar-item__icon"
                }, null, 8, ["name"]),
                (route.children)
                  ? (_openBlock(), _createBlock(_component_va_icon, {
                      key: 0,
                      class: "more_icon",
                      name: dropdownsValue.value[idx] ? 'chevron_left' : 'chevron_right'
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["active", "to"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children, (child, index) => {
            return (_openBlock(), _createBlock(_component_va_sidebar_item, {
              key: index,
              active: isRouteActive(child),
              to: { name: child.name }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)(child.displayName)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["active", "to"]))
          }), 128))
        ])
      ]),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue"]))
  }), 128))
}
}

})